import { HAND_CONNECTIONS } from "../gestures/landmarks.ts";
import type { HandFrame, Rect } from "../utils/types.ts";

export function drawHandOverlay(
  ctx: CanvasRenderingContext2D,
  hands: HandFrame[],
  width: number,
  height: number,
  debug: {
    enabled: boolean;
    boxes: Rect[];
    fallback: boolean;
  },
): void {
  ctx.save();
  ctx.lineWidth = Math.max(1.5, width * 0.004);
  ctx.lineJoin = "round";
  ctx.lineCap = "round";

  for (const hand of hands) {
    const color = hand.handedness === "Left" ? "#00f0ff" : "#ff2bd6";
    ctx.strokeStyle = color;
    ctx.fillStyle = color;
    ctx.shadowColor = color;
    ctx.shadowBlur = 12;
    ctx.beginPath();
    for (const [a, b] of HAND_CONNECTIONS) {
      const pa = hand.landmarks[a];
      const pb = hand.landmarks[b];
      if (!pa || !pb) continue;
      ctx.moveTo(pa.x * width, pa.y * height);
      ctx.lineTo(pb.x * width, pb.y * height);
    }
    ctx.stroke();
    for (const point of hand.landmarks) {
      ctx.beginPath();
      ctx.arc(point.x * width, point.y * height, Math.max(2.2, width * 0.007), 0, Math.PI * 2);
      ctx.fill();
    }
  }

  if (debug.enabled) {
    ctx.shadowBlur = 0;
    ctx.strokeStyle = debug.fallback ? "#ff3b6b" : "#5dffc8";
    ctx.lineWidth = 2;
    ctx.setLineDash([6, 4]);
    for (const box of debug.boxes) {
      ctx.strokeRect(box.x, box.y, box.width, box.height);
    }
    ctx.setLineDash([]);
  }
  ctx.restore();
}

export function drawFallbackBanner(
  ctx: CanvasRenderingContext2D,
  width: number,
  height: number,
): void {
  ctx.save();
  ctx.fillStyle = "rgba(0, 0, 0, 0.35)";
  ctx.fillRect(0, 0, width, height * 0.12);
  ctx.fillStyle = "#00f0ff";
  ctx.font = `${Math.max(11, width * 0.035)}px "Segoe UI", sans-serif`;
  ctx.letterSpacing = "0.12em";
  ctx.fillText("PRIVACY FALLBACK ACTIVE.", width * 0.04, height * 0.075);
  ctx.restore();
}
